export const highlightedMockDepPort: string[] = ['ALC', 'NAP', 'VCE', 'CVV']
export const highlightedMockShip: string[] = ['AX', 'BE', 'FA', 'MA']
export const highlightedMockArea: string[] = ['CAR', 'MED', 'INW', 'NOA']
export const highlightedMockCabin: string[] = ['INS', 'OUT', 'OUB', 'SUI', 'YCB']
